module.exports = __webpack_public_path__ + "img/03-title-02-m.a8c0d10e.png";